import { render, staticRenderFns } from "./tabWarehousingDetail.vue?vue&type=template&id=01d6de62&"
import script from "./tabWarehousingDetail.vue?vue&type=script&lang=js&"
export * from "./tabWarehousingDetail.vue?vue&type=script&lang=js&"
import style0 from "./tabWarehousingDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01d6de62')) {
      api.createRecord('01d6de62', component.options)
    } else {
      api.reload('01d6de62', component.options)
    }
    module.hot.accept("./tabWarehousingDetail.vue?vue&type=template&id=01d6de62&", function () {
      api.rerender('01d6de62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabWarehousingDetail.vue"
export default component.exports